import React from 'react';

import { Routes, Route } from 'react-router-dom';

import Loginpage from '../pages/loginPage';

const AuthRoutes: React.FC = () => (
    <Routes>
        <Route path="/" element={<Loginpage />} />
    </Routes>
);

export default AuthRoutes;